const productManagementEn = {
    product: require('lang/en/product_management/Product').default,
    pricing: require('lang/en/product_management/Pricing').default,
    recipe: require('lang/en/product_management/Recipe').default,
};

export default productManagementEn;